module.exports = __webpack_public_path__ + "assets/img/btn-view-e2c856f6.png";